const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M3.75 3a.75.75 0 0 0-1.5 0v18c0 .414.336.75.75.75h18a.75.75 0 0 0 0-1.5H3.75z"/><path d="M21.03 4.03a.75.75 0 0 0-1.06-1.06l-14.5 14.5a.75.75 0 1 0 1.06 1.06z"/></svg>';
export {
  a as w
};
